<template>
  <el-dialog 
    :title="$t('order.addAddress')"
    :visible.sync="dialogVisible"
    width="50%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="addressForm" label-width="120px">
      <el-form-item :label="$t('order.receiverName')" prop="username">
        <el-input v-model="form.username" maxlength="20"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('order.phoneNumber')" prop="tel">
        <el-input v-model="form.tel" maxlength="11"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('order.region')" prop="areaName">
        <el-row :gutter="10">
          <el-col :span="8">
            <el-select 
              v-model="form.selectProv" 
              :placeholder="$t('order.selectProvince')"
              @change="getProv(form.selectProv)"
              style="width:100%"
            >
              <el-option
                v-for="item in provs"
                :key="item.areaCode"
                :label="item.areaName"
                :value="item.areaCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select 
              v-model="form.selectCity" 
              :placeholder="$t('order.selectCity')"
              @change="getCity(form.selectCity)"
              style="width:100%"
            >
              <el-option
                v-for="item in citys"
                :key="item.areaCode"
                :label="item.areaName"
                :value="item.areaCode">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select 
              v-model="form.selectArea" 
              :placeholder="$t('order.selectDistrict')"
              @change="getArea(form.selectArea)"
              style="width:100%"
            >
              <el-option
                v-for="item in areas"
                :key="item.areaCode"
                :label="item.areaName"
                :value="item.areaCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </el-form-item>
      
      <el-form-item :label="$t('order.detailAddress')" prop="address">
        <el-input v-model="form.address" maxlength="30"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('order.postalCode')">
        <el-input v-model="form.postalCode" maxlength="6"></el-input>
      </el-form-item>
      
      <el-form-item>
        <el-checkbox v-model="form.isDefault">{{ $t('order.setDefault') }}</el-checkbox>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="saveAddress">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveAddress, listAreas } from '@/api/plateform/order/orderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddressDialog',
  data() {
    return {
      dialogVisible: false,
      form: {
        selectProv: '',
        selectCity: '',
        selectArea: '',
        addressId: '',
        userId: '',
        areaName: '',
        address: '',
        areaCode: '',
        username: '',
        tel: '',
        postalCode: '',
        isDefault: false
      },
      provs: [],
      citys: [],
      areas: [],
      rules: {
        username: [
          { required: true, message: this.$t('order.receiverNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('order.receiverNameMaxLength'), trigger: 'blur' }
        ],
        tel: [
          { required: true, message: this.$t('order.phoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('order.phoneFormatError'), trigger: 'blur' }
        ],
        address: [
          { required: true, message: this.$t('order.addressRequired'), trigger: 'blur' },
          { max: 50, message: this.$t('order.addressMaxLength'), trigger: 'blur' }
        ],
        areaName: [
          { required: true, message: this.$t('order.regionRequired'), trigger: 'change' }
        ]
      },
      shopId: ''
    }
  },
  created() {
    this.shopId = getShopId()
    this.getProvList()
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.resetForm()
    },
    handleClose() {
      this.$refs.addressForm.resetFields()
    },
    resetForm() {
      this.form = {
        selectProv: '',
        selectCity: '',
        selectArea: '',
        addressId: '',
        userId: this.$store.getters.userId,
        areaName: '',
        address: '',
        areaCode: '',
        username: '',
        tel: '',
        postalCode: '',
        isDefault: false
      }
    },
    async getProvList() {
      try {
        const res = await listAreas({
          areaLevel: '101',
          parentAreaCode: '0'
        })
        this.provs = res.data
      } catch (error) {
        console.error('获取省份列表失败:', error)
      }
    },
    async getProv(provCode) {
      try {
        const res = await listAreas({
          areaLevel: '202',
          parentAreaCode: provCode
        })
        this.citys = res.data
        this.form.selectCity = ''
        this.form.selectArea = ''
      } catch (error) {
        console.error('获取城市列表失败:', error)
      }
    },
    async getCity(cityCode) {
      try {
        const res = await listAreas({
          areaLevel: '303',
          parentAreaCode: cityCode
        })
        this.areas = res.data
        this.form.selectArea = ''
      } catch (error) {
        console.error('获取区县列表失败:', error)
      }
    },
    getArea(areaCode) {
      this.form.areaCode = areaCode
      this.form.areaName = this.getFullAreaName()
    },
    getFullAreaName() {
      let areaName = ''
      this.provs.forEach(item => {
        if (item.areaCode === this.form.selectProv) {
          areaName += item.areaName
        }
      })
      this.citys.forEach(item => {
        if (item.areaCode === this.form.selectCity) {
          areaName += item.areaName
        }
      })
      this.areas.forEach(item => {
        if (item.areaCode === this.form.selectArea) {
          areaName += item.areaName
        }
      })
      return areaName
    },
    saveAddress() {
      this.$refs.addressForm.validate(async valid => {
        if (!valid) return
        
        try {
          const params = {
            ...this.form,
            isDefault: this.form.isDefault ? '1' : '0',
            areaName: this.getFullAreaName()
          }
          
          await saveAddress(params)
          this.$message.success(this.$t('order.saveSuccess'))
          this.dialogVisible = false
          this.$emit('refresh')
        } catch (error) {
          console.error('保存地址失败:', error)
        }
      })
    }
  }
}
</script>

<style scoped>
/* 可以添加自定义样式 */
</style>